import('lightgallery.js')
.then(() => {
    lightGallery(document.querySelector('.lightgallery'));
})
